import React from "react";

import {type MotionValue} from "framer-motion";

export const ScrollContainerContext = React.createContext<{
    scrollY: MotionValue<number>;
    // SimpleScene's bounded rewinding scroll — what its own title and menu
    // scale off, so custom titleSections can match the house physics.
    scrollYBoundedProgress: MotionValue<number>;
    scrollTo: (top: number, duration?: number) => void;
} | null>(null);
